// extracted by mini-css-extract-plugin
export default {"logoArea":"TNhhMltbvlGJmWgLd9F5","linkBtn":"QP1fgnfNl3ak5aLI38nQ","common_bganimation":"SSKG4kqR6yusIvX6650g"};